var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignal03 = function SvgSignal03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#681feaf3-6127-4fa9-8100-588b02965f9fa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#60646C",
    fillRule: "evenodd",
    d: "M13.143 3.757a6 6 0 0 0-8.486 8.486.667.667 0 1 1-.943.942 7.333 7.333 0 1 1 10.371 0 .667.667 0 1 1-.943-.942 6 6 0 0 0 0-8.486m-1.886 1.886a3.333 3.333 0 0 0-4.714 4.714.667.667 0 1 1-.943.943 4.667 4.667 0 1 1 6.6 0 .667.667 0 1 1-.943-.943 3.333 3.333 0 0 0 0-4.714M9.37 7.529a.667.667 0 0 0-.943.942.667.667 0 1 1-.942.943 2 2 0 1 1 2.828 0 .667.667 0 0 1-.943-.943.667.667 0 0 0 0-.942",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "681feaf3-6127-4fa9-8100-588b02965f9fa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.9 0h16v16H.9z"
  })))));
};
export default SvgSignal03;